import { Middleware } from '@nuxt/types';

const ExperimentMiddleware: Middleware = async context => {
  await context.$amplitudeExperimentRefetchVariants();
};

export default ExperimentMiddleware;
